import axios from 'axios';
import { toast } from 'sonner';

/**
 * Setup Axios Interceptor for Subscription Guard Errors
 * Handles 402 Payment Required responses.
 * Does NOT logout on network errors / 5xx (backend restart resilience).
 */
export const setupSubscriptionGuardInterceptor = (navigate) => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;

      // Handle 402 Payment Required (Subscription Guard)
      if (status === 402) {
        const errorData = error.response.data;
        
        if (errorData?.code) {
          const { code, message } = errorData;
          
          if (code === 'ACCOUNT_SUSPENDED') {
            toast.error('Account gesperrt', {
              description: message || 'Ihr Account wurde gesperrt. Bitte aktualisieren Sie Ihre Zahlungsmethode.',
              duration: 5000,
              action: {
                label: 'Zur Zahlung',
                onClick: () => navigate?.('/admin/subscription')
              }
            });
            setTimeout(() => {
              if (navigate) navigate('/admin/subscription');
            }, 1000);
            
          } else if (code === 'ACCOUNT_UNPAID') {
            toast.warning('Read-Only Modus', {
              description: message || 'Ihr Account ist im Read-Only Modus. Änderungen sind nicht möglich.',
              duration: 5000,
              action: {
                label: 'Zahlungsmethode aktualisieren',
                onClick: () => navigate?.('/admin/subscription')
              }
            });
          } else if (code === 'SUBSCRIPTION_CANCELLED') {
            // Reguläre/manuelle Kündigung → KEIN "Zahlungsproblem"-Toast (kein Zahlungsfehler)
            // OnboardingContext leitet bereits korrekt zum Exporte-Modul.
            // Stiller Durchlass – der Guard hat den Endpunkt blockiert, aber das ist erwartet.
          } else {
            toast.error('Zahlungsproblem', {
              description: message || 'Es gibt ein Problem mit Ihrem Abonnement.',
              action: {
                label: 'Details ansehen',
                onClick: () => navigate?.('/admin/subscription')
              }
            });
          }
        } else {
          toast.error('Zugriff eingeschränkt', {
            description: 'Bitte überprüfen Sie Ihr Abonnement.',
            action: {
              label: 'Zur Übersicht',
              onClick: () => navigate?.('/admin/subscription')
            }
          });
        }
      }

      // Network errors (backend restart) — pass through silently
      // do NOT show error toasts for transient network failures
      
      return Promise.reject(error);
    }
  );
};

export const setupBasicSubscriptionGuardInterceptor = () => {
  setupSubscriptionGuardInterceptor(null);
};
